






























































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Str } from '@/modules/shared/helpers'
import { Prop, Watch } from 'vue-property-decorator'
import { makeImageBlob } from '@/modules/shared/helpers/utils/file'
import { AttachmentSerializer } from '@/modules/media/serializers/AttachmentSerializer'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

const defaultFormats = [
  '.jpg',
  '.bmp',
  '.png',
  '.html',
  '.txt',
  '.docx',
  '.doc',
  '.xls',
  '.csv',
  '.zip',
  '.rar'
]
@Component({
  components: { BaseButton }
})
export default class PanelUploader extends Vue {
  constructor(
    private readonly str: Str
  ) {
    super()
  }

  @Prop({
    required: true
  }) protected value: any[]

  @Prop({
    default: () => defaultFormats
  }) formats!: typeof defaultFormats

  @Prop({
    default: 3
  }) maxFiles!: number

  @Prop({
    default: 'box'
  }) displayType!: string

  @Prop() label!: string

  @Prop() errors!: string[]

  get text() {
    return this.$q.screen.lt.md
      ? 'جهت آپلود ضربه بزنید'
      : 'جهت آپلود ضربه بزنید یا فایل را اینجا رها کنید'
  }

  showHeader(filesLength: number) {
    return (filesLength > 0) && (filesLength < this.maxFiles)
  }

  @Watch('value', {
    immediate: true
  })
  propChange() {
    const strings = this.value.filter(value => typeof value === 'string')
    const attachments = this.value.filter(value => AttachmentSerializer.isAttachment(value))

    if (strings.length > 0) {
      Promise.all(this
        .value
        .map(src => makeImageBlob(src))
      ).then(all => this.setFiles(all))
    } else if (attachments.length > 0) {
      Promise.all(this
        .value
        .map((attachment: AttachmentSerializer) => makeImageBlob(
          attachment.url,
          attachment.name
        ))
      ).then(all => this.setFiles(all))
    }

    if (this.$refs.uploader) {
      this.setFiles()
    } else {
      this.$nextTick(this.setFiles)
    }
  }

  setFiles(value?) {
    if (value) {
      ;(this.$refs.uploader as any).files = value
      ;(this.$refs.uploader as any).queuedFiles = value
      this.fileChange(value)
    } else {
      ;(this.$refs.uploader as any).files = this.value
    }
  }

  fileChange(value) {
    const files = (this.$refs.uploader as any).files
    this.$emit('input', files)
  }

  removeFile(vm, file) {
    vm.removeFile(file)
  }

  get acceptFormats() {
    return this.formats.join(',')
  }

  get uploaderAttributes() {
    if (this.displayType == 'button') {
      return {
        'class': 'full-width no-shadow tes-button-uploader',
        'accept': this.acceptFormats
      }
    }

    return {
      ...this.$attrs,
      'class': 'tes-uploader full-width bg-tes-blue-light ',
      'color': 'tes-blue-light',
      'text-color': 'tes-blue',
      'multiple': true,
      'flat': true,
      'accept': this.acceptFormats,
      'bordered': true
    }
  }

  get addButtonAttributes() {
    if (this.displayType == 'button') {
      return {
        'unelevated': true,
        'text-color': 'white',
        'color': 'tes-navy-blue-dark',
        'button-class': 'bg-tes-navy-blue-dark q-px-md',
        'dense': false,
        'type': 'button'
      }
    }

    return {
      'unelevated': true,
      'text-color': 'tes-navy-blue-dark',
      'button-class': 'q-px-md no-hover',
      'dense': true,
      'type': 'a'
    }
  }
}
